import { useEffect } from 'react';

// Pista de «desliza» para las tablas anchas (.table-wrapper). Marca cada una
// con `desliza-der` / `desliza-izq` cuando hay más contenido por ver a ese lado;
// el CSS (index.css) desvanece el borde correspondiente. Sin esto, en el celular
// las columnas y acciones de la derecha quedan escondidas sin avisar.
const MARGEN = 2; // px de tolerancia por redondeos del navegador

function marcar(wrapper) {
  const max = wrapper.scrollWidth - wrapper.clientWidth;
  wrapper.classList.toggle('desliza-der', max > MARGEN && wrapper.scrollLeft < max - MARGEN);
  wrapper.classList.toggle('desliza-izq', max > MARGEN && wrapper.scrollLeft > MARGEN);
}

export default function useTablasDeslizables() {
  useEffect(() => {
    const vigiladas = new Set();
    const onScroll = (e) => marcar(e.currentTarget);
    // Cambia el ancho del contenedor (girar el celular) o el de la tabla (llegan filas).
    const ro = new ResizeObserver((entradas) => {
      entradas.forEach((en) => {
        const wrapper = en.target.closest('.table-wrapper');
        if (wrapper) marcar(wrapper);
      });
    });

    const soltar = (wrapper) => {
      wrapper.removeEventListener('scroll', onScroll);
      vigiladas.delete(wrapper);
    };

    const revisar = () => {
      vigiladas.forEach((w) => { if (!w.isConnected) soltar(w); });
      document.querySelectorAll('.table-wrapper').forEach((wrapper) => {
        if (!vigiladas.has(wrapper)) {
          vigiladas.add(wrapper);
          wrapper.addEventListener('scroll', onScroll, { passive: true });
          ro.observe(wrapper);
        }
        const tabla = wrapper.querySelector('table');
        if (tabla) ro.observe(tabla); // observar dos veces el mismo nodo no hace nada
        marcar(wrapper);
      });
    };

    // Las tablas aparecen cuando cargan los datos o se abre un modal: se revisa
    // el DOM, como máximo una vez por cuadro.
    let pendiente = 0;
    const mo = new MutationObserver(() => {
      if (!pendiente) {
        pendiente = requestAnimationFrame(() => { pendiente = 0; revisar(); });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    revisar();

    return () => {
      mo.disconnect();
      ro.disconnect();
      if (pendiente) cancelAnimationFrame(pendiente);
      vigiladas.forEach((w) => w.removeEventListener('scroll', onScroll));
      vigiladas.clear();
    };
  }, []);
}
